import { useEffect, useState } from 'react';

import { loadScript } from '#src/lib/script.ts';

declare global {
  interface Window {
    ApplePaySession?: any;
  }
}

const SDK_URL = 'https://applepay.cdn-apple.com/jsapi/v1.3.2/apple-pay-sdk.js';

const SDK_HASH =
  'sha384-DZRWMZLyVXr+7shJfal8pIG2v4KisLoSWFjZQMUv0+GWaCwoa82qeHsWrbBIUDPU';

const checkCanUseApplePay = () =>
  // oxlint-disable-next-line sorare/no-window-location
  window.location.protocol === 'https:' &&
  !!window.ApplePaySession &&
  ApplePaySession.canMakePayments();

export const useCanUseApplePay = () => {
  const [canUseApplePay, setCanUseApplePay] = useState(checkCanUseApplePay);

  useEffect(() => {
    if (canUseApplePay) return;

    loadScript(SDK_URL, {
      integrity: SDK_HASH,
      crossOrigin: 'anonymous',
    })
      .then(() => {
        setCanUseApplePay(checkCanUseApplePay());
      })
      .catch(() => {
        // SDK failed to load — Apple Pay remains unavailable
      });
  }, [canUseApplePay]);

  return canUseApplePay;
};
